// extracted by mini-css-extract-plugin
var _1 = "EntityProfileHeaderAvatar-moduleskeleton__WIuD0 Skeleton-moduleSkeleton__Mlrfv";
export { _1 as "skeleton" }
